module.exports = __webpack_public_path__ + "static/media/photoshop.647f3941.png";